import styled from "styled-components";

export const GatewayDataDebugWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0px;
    padding: 0px 20px;
`;

export const ToolBarLeftWrapper = styled.div`
    flex: 0 0 auto;
`;

export const ToolBarRightWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & .ant-select-selector {
        overflow: hidden;
    }

    & .ant-select-selection-overflow {
        flex-wrap: nowrap;
    }
`;

export const FilterItemLabel = styled.div`
    font-size: 12px;
    color: #333333;
    text-align: left;
    padding-left: 10px;
    margin-bottom: 5px;
    box-sizing: border-box;
    letter-spacing: 2px;
`;

export const DataSendingAndReceivingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const DataReceivingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 500px;
    margin-bottom: 10px;
    border: 1px solid rgb(217, 217, 217);
    overflow-y: auto;
`;

export const DataReceivingPacketWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 10px 0px;
    padding: 10px;
`;

export const PacketData = styled.div`
    color: #EFEFEF;
    background-color: #333333;
    border-radius: 5px;
    padding: 10px;
`;

export const PacketTime = styled.div`
    color: #666666;
    margin: 5px 10px;
`;

export const DataSendingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;
